import React, { useState } from "react";
import ProgressBar from "Components/shared/progressbar";
import styles from './transfer.module.css';
import { useNavigate } from 'react-router-dom';
import { HeaderItem, StageHeader, Stages } from 'Components/shared/progress';
import { SelectBeneficiary, Summary } from 'Components/main_components/transfer/saved_beneficiary';
import Modal from 'Components/shared/modal';
import Text from 'Components/shared/text';
import AuthCodeInput from 'Components/main_components/registeration/AuthCodeInput';
import Button from 'Components/shared/button';
import { PinInput, TransactionEnd } from 'Components/main_components/transfer/reusables';
import Hidden from "Components/shared/hidden";
import Back from "Components/main_components/registeration/Back";
import { Amount, BeneficiaryDetails } from "Components/main_components/transfer/new_account";
import useForm from "hooks/useForm";
import validateBeneficiary from "utils/validators/beneficiary";


const NewAccount = () => {
    const navigate = useNavigate();

 

    //Form Related States
    const initialState ={
        bank: '',
        country:"",
        name:"",
        swift:"",
        iban:"",
        account:"",
        currency:""
    }
    const submitHandler = async(values,{ errors, setSubmitting, setErrors }) => {
        console.log(values);

    }
    const {handleSubmit, values, errors, isSubmitting, touched, handleUpdate} = useForm({
        initialState,
        submitHandler,
        validate: validateBeneficiary
    });
  
    return(
        <div className={styles.Beneficiary}>
         <div className="w-full" style={{padding:"30px", borderBottom:"1px solid #E2E8F0"}}>
            <Back onClick={() => navigate(-1)} />
         </div>
        
         <BeneficiaryDetails {...{handleUpdate, values, errors, touched }} />
         
        </div>
    )
}

export default NewAccount;
